// @ts-nocheck

import { createSelector } from 'reselect';

import { GRNotificationTypes } from '../../types/notification';
import { selectGRMiscCurrentNotification, selectGRMiscTmpNotifications } from '../misc';

export const selectShowGRRoundFailedNotification = createSelector(
  [selectGRMiscCurrentNotification, selectGRMiscTmpNotifications],
  (currentNotif, notifications) =>
    currentNotif && currentNotif.type === GRNotificationTypes.ROUND_FAILED && notifications.length === 1,
);

const selectGRRoundFailedNotificationProps = createSelector([selectShowGRRoundFailedNotification], (show) => ({
  show,
}));

export default selectGRRoundFailedNotificationProps;
